import { jsx } from "react/jsx-runtime";
import "react";
import { Divider } from "@zillow/constellation";
import PropTypes from "prop-types";
import { CustomPropTypes } from "@zillow/zrs-cms";
const BlockDivider = ({
  attrs,
  index
}) => {
  const {
    appearance = "regular",
    length = {
      default: "auto"
    },
    margin = {
      marginBottom: {
        default: "sm"
      }
    }
  } = attrs;
  return /* @__PURE__ */ jsx(Divider, { appearance, length, orientation: {
    default: "horizontal",
    lg_lte: "horizontal",
    sm_lte: "horizontal"
  }, ...margin }, index);
};
BlockDivider.propTypes = {
  attrs: PropTypes.shape({
    appearance: PropTypes.string,
    length: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    margin: PropTypes.shape({
      marginBottom: CustomPropTypes.inlineMediaQuery(PropTypes.string),
      marginTop: CustomPropTypes.inlineMediaQuery(PropTypes.string)
    })
  }),
  index: PropTypes.number
};
export {
  BlockDivider as default
};
